import { Action } from '@ngrx/store';
import { MainFilter, Client, Account, StaticDataPayload, ResourceRequestPayload } from './main.models';
import { CountryStaticData, PageNotes, StaticData } from '../../global/interfaces';

export enum ActionTypes {
  LOAD_MAIN_CLIENTS = '[Main] Load All Clients Action',
  LOAD_MAIN_CLIENTS_SUCCESS = '[Main] Load All Clients Success Action',
  LOAD_MAIN_CLIENTS_FAILED = '[Main] Load All Clients Failed Action',

  SET_MAIN_FILTER = '[Main] Set Main Filter Action',
  SET_MAIN_FILTER_CLIENT = '[Main] Set Main Filter Client Action',
  SET_MAIN_FILTER_ACCOUNT = '[Main] Set Main Filter Account Action',

  LOAD_STATIC_DATA = '[Main] Load Select Data Action',
  LOAD_STATIC_DATA_SUCCESS = '[Main] Load Select Data Success Action',
  LOAD_STATIC_DATA_FAILED = '[Main] Load Select Data Failed Action',

  SET_STATIC_DATA = '[Main] Set Static Data Action',
  SET_STATIC_DATA_SUCCESS = '[Main] Set Static Data Success Action',
  SET_STATIC_DATA_FAILED = '[Main] Set Static Data Failed Action',

  LOAD_PAGE_NOTES = '[Main] Load Page Notes Action',
  LOAD_PAGE_NOTES_SUCCESS = '[Main] Load Page Notes Success Action',
  LOAD_PAGE_NOTES_FAILED = '[Main] Load Page Notes Failed Action',

  SET_SELECTED_COUNTRY = '[Main] Set Selected Country',

  LOAD_LOG_IN_CONTACT_US = '[Main] Load Contact Us Log In',
  LOAD_LOG_IN_CONTACT_US_SUCCESS = '[Main] Load Contact Us Log In Success Action',
  LOAD_LOG_IN_CONTACT_US_FAILED = '[Main] Load Contact Us Log In Failed Action',

  CREATE_RESOURCE_REQUEST = '[Resource Center] Create Resource Request Action',
  CREATE_RESOURCE_REQUEST_SUCCESS = '[Resource Center] Create Resource Request Success Action',
  CREATE_RESOURCE_REQUEST_FAILED = '[Resource Center] Create Resource Request Failed Action'
}

export class LoadMainClientsAction implements Action {
  readonly type = ActionTypes.LOAD_MAIN_CLIENTS;
  public constructor(public payload: any) {
  }
}

export class LoadMainClientsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_MAIN_CLIENTS_SUCCESS;

  public constructor(public payload: Client[]) {
  }
}

export class LoadMainClientsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_MAIN_CLIENTS_FAILED;
}

export class SetMainFilterAction implements Action {
  readonly type = ActionTypes.SET_MAIN_FILTER;

  public constructor(public payload: MainFilter) {
  }
}

export class SetMainFilterClientAction implements Action {
  readonly type = ActionTypes.SET_MAIN_FILTER_CLIENT;

  public constructor(public payload: Client[]) {
  }
}

export class SetMainFilterAccountAction implements Action {
  readonly type = ActionTypes.SET_MAIN_FILTER_ACCOUNT;

  public constructor(public payload: Account[]) {
  }
}

export class LoadStaticDataAction implements Action {
  readonly type = ActionTypes.LOAD_STATIC_DATA;

  public constructor(public payload?: string) {
  }
}

export class LoadStaticDataSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_STATIC_DATA_SUCCESS;

  public constructor(public payload: StaticData) {
  }
}

export class LoadStaticDataFailedAction implements Action {
  readonly type = ActionTypes.LOAD_STATIC_DATA_FAILED;
}

export class LoadLoginContactUsAction implements Action {
  readonly type = ActionTypes.LOAD_LOG_IN_CONTACT_US;

}

export class LoadLoginContactUsSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_LOG_IN_CONTACT_US_SUCCESS;

  public constructor(public payload: CountryStaticData[]) {
  }
}


export class LoadLoginContactUsFailedAction implements Action {
  readonly type = ActionTypes.LOAD_LOG_IN_CONTACT_US_FAILED;
}
export class LoadPageNotesAction implements Action {
  readonly type = ActionTypes.LOAD_PAGE_NOTES;
}

export class LoadPageNotesSuccessAction implements Action {
  readonly type = ActionTypes.LOAD_PAGE_NOTES_SUCCESS;

  public constructor(public payload: PageNotes) {
  }
}

export class LoadPageNotesFailedAction implements Action {
  readonly type = ActionTypes.LOAD_PAGE_NOTES_FAILED;
}

export class SetStaticDataAction implements Action {
  readonly type = ActionTypes.SET_STATIC_DATA;

  public constructor(public payload: StaticDataPayload[]) {
  }
}

export class SetStaticDataSuccessAction implements Action {
  readonly type = ActionTypes.SET_STATIC_DATA_SUCCESS;

  public constructor(public payload: StaticDataPayload[]) {
  }
}

export class SetStaticDataFailedAction implements Action {
  readonly type = ActionTypes.SET_STATIC_DATA_FAILED;
}

export class SetSelectedCountryAction implements Action {
  readonly type = ActionTypes.SET_SELECTED_COUNTRY;
  public constructor(public payload: any) {
  }
}


export class CreateResourceRequestAction implements Action {
  readonly type = ActionTypes.CREATE_RESOURCE_REQUEST;

  public constructor(public payload: ResourceRequestPayload) {
  }
}

export class CreateResourceRequestSuccessAction implements Action {
  readonly type = ActionTypes.CREATE_RESOURCE_REQUEST_SUCCESS;

  public constructor(public payload: any) {
  }
}

export class CreateResourceRequestFailedAction implements Action {
  readonly type = ActionTypes.CREATE_RESOURCE_REQUEST_FAILED;
}

export type Actions =
  LoadMainClientsAction |
  LoadMainClientsSuccessAction |
  LoadMainClientsFailedAction |
  SetMainFilterAction |
  SetMainFilterClientAction |
  SetMainFilterAccountAction |
  LoadStaticDataAction |
  LoadStaticDataSuccessAction |
  LoadStaticDataFailedAction |
  SetStaticDataAction |
  SetStaticDataSuccessAction |
  SetStaticDataFailedAction |
  LoadPageNotesAction |
  LoadPageNotesSuccessAction |
  LoadPageNotesFailedAction |
  SetSelectedCountryAction |
  LoadLoginContactUsAction |
  LoadLoginContactUsSuccessAction |
  LoadLoginContactUsFailedAction |
  CreateResourceRequestAction |
  CreateResourceRequestSuccessAction |
  CreateResourceRequestFailedAction;
